import { TenantGeneralData } from '../tenantGeneralData';

export class JobSetting extends TenantGeneralData {
  preferences: Array<JobPreference>;

  constructor() {
    super();
    this.preferences = [];
  }
}

export class JobPreference {
  key?: string;
  value?: string;
  type?: string; // INTEGER,LONG,DOUBLE,STRING,BOOLEAN
  constructor() {
    this.key = null;
    this.value = null;
    this.type = null;
  }
}
